// Local Storage Keys
export const STORAGEKEY_CLIENT_ID = 'clientId';
export const STORAGEKEY_THEME = 'theme';
export const STORAGEKEY_IMPERSONATE = 'Impersonate';
export const STORAGEKEY_LAST_PENDING_LOGOUT = 'lastPendingLogout';
export const STORAGEKEY_LAST_CONFIRMED_LOGOUT = 'lastConfirmedLogout';
export const STORAGEKEY_LAST_CANCELLED_LOGOUT = 'lastCancelledLogout';
export const STORAGEKEY_LAST_SESSION_ACTIVITY = 'lastSessionActivity';
export const STORAGEKEY_LAST_SESSION_HEARTBEAT = 'lastSessionHeartbeat';
export const STORAGEKEY_LAST_SESSION_WARNING = 'lastSessionWarning';
export const STORAGEKEY_LAST_SESSION_EXTENSION = 'lastSessionExtension';
export const STORAGEKEY_ACTIVITY_MONITOR_CONFIG_OVERRIDE =
    'ActivityMonitorConfigOverride';
